var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isRecordEmpty } from 'hx-util';
import { useCallback, useEffect, useState } from 'react';
import { useMountedState } from 'react-use';
import { connect, Logger } from 'twilio-video';
var INITIAL_STATE = {
    room: {},
    error: null,
};
var logger = Logger.getLogger('twilio-video');
logger.setLevel('silent');
export var useRoomConnection = function (_a) {
    var _b = _a === void 0 ? {} : _a, onDisconnected = _b.onDisconnected, onConnected = _b.onConnected;
    var _c = useState(INITIAL_STATE), roomState = _c[0], setRoomState = _c[1];
    var room = roomState.room;
    var isMounted = useMountedState();
    var connectRoom = useCallback(function (_a) {
        var token = _a.token, options = _a.options;
        connect(token, options)
            .then(function (room) {
            if (!isMounted())
                room.disconnect();
            else {
                setRoomState(function (c) { return (__assign(__assign({}, c), { room: room })); });
                console.log("Successfully joined a Room: ".concat(room));
            }
        })
            .catch(function (error) {
            if (!isMounted())
                room.disconnect();
            else {
                setRoomState(function (c) { return (__assign(__assign({}, c), { error: error })); });
                console.error("Unable to connect to Room: ".concat(error.message));
            }
        });
    }, []);
    var disconnectRoom = useCallback(function () {
        if (!room || !('disconnect' in room))
            return;
        room.disconnect();
    }, [room]);
    useEffect(function () {
        if (isRecordEmpty(room))
            return;
        window.addEventListener('beforeunload', disconnectRoom);
        window.addEventListener('pagehide', disconnectRoom);
        room.once('disconnected', function () {
            onDisconnected === null || onDisconnected === void 0 ? void 0 : onDisconnected();
            window.removeEventListener('beforeunload', disconnectRoom);
            window.removeEventListener('pagehide', disconnectRoom);
        });
        room.once('connected', function () {
            onConnected === null || onConnected === void 0 ? void 0 : onConnected(room);
        });
        return function () {
            window.removeEventListener('beforeunload', disconnectRoom);
            window.removeEventListener('pagehide', disconnectRoom);
        };
    }, [disconnectRoom, room]);
    return __assign(__assign({}, roomState), { disconnectRoom: disconnectRoom, connectRoom: connectRoom });
};
